<template>
	<div>
		<div style="padding:0 15px">
			<p class="title">
				{{tenderInfo.title}}
			</p>
			<p class="titleChild">项目编号：{{tenderInfo.projectSn}}</p>
			<p class="titleChild">招标方式：{{tenderInfo.bidMethodName}}</p>
			<p class="titleChild">发布时间：{{tenderInfo.publishDate}}</p>
			<p class="titleChild">报名截止时间：{{tenderInfo.deadlineDate}}</p>
		</div>
		
		<van-divider :style="{ borderColor: '#DCDFE6'}"/>
		<div style="padding: 0 15px 15px 15px;">
			<div v-html="tenderInfo.content" id="wangTable">
			</div>
      <p v-for="(item,index) in tenderInfo.fileList" :key="index" style="margin:5px 0;">
        <span>附件下载：</span>
        <span style="cursor:pointer;color: #0D81D6;" @click="loadFile(item.url,item.fileName)">{{item.fileName}}</span>
      </p>
		</div>
		
	</div>
</template>

<script>
import Vue from 'vue';
import { Divider } from 'vant';
Vue.use(Divider)
export default {
	name:'tenderContent',
	data() {
		return {
			tenderInfo:{
				name:'',
        projectSn:'',
        bidMethodName:0,
        publishDate:'',
        deadlineDate:'',
			}
		}
	},
	methods: {
		loadFile(path) {
      return window.open(path,'_blank');
		}		
	},
	mounted:function(){
			var that=this;
			let tenderId = this.$route.query.id;
			this.$axios.get(this.baseUrl4+'bidNotice/'+tenderId).then(response=>{
				if(response.data.code!='200'){
					that.$alert(response.data.msg, '提示', {confirmButtonText: '确定'});
				}else{
          Object.assign(this.tenderInfo,response.data.data)
				}
			}).catch(function (error) {window.console.log(error)});//ajax请求失败
	},

}
</script>

<style scoped>
	.title{font-size: 15px;font-weight: 600;}
	.titleChild{margin:3px 0;font-size: 14px;color: #606266;}
</style>
